import React from "react";
import TransferArticleToWarehouseButtonProperties from "./TransferArticleToWarehouseButtonProperties";
import {useI18nContext} from "../../../contexts/I18nContext";
import TransferArticleToWarehouseStore from "./TransferArticleToWarehouseStore";
import WarehouseIcon from "@mui/icons-material/Warehouse";
import RoundedButton from "../../../ui_components/RoundedButton/RoundedButton";
import Modal from "../../../ui_components/Modal/Modal";
import {Observer} from "mobx-react-lite";
import {useStyles} from "./TransferArticleToWarehouseButton.style";
import Button from "../../../ui_components/Button/Button";
import ButtonType from "../../../ui_components/Button/ButtonType";
import {useCommonContext} from "../../../contexts/CommonContext";
import ButtonSize from "../../../ui_components/Button/ButtonSize";
import CommentInput from "../../Inputs/CommentInput/CommentInput";
import Alert from "../../../ui_components/Alert/Alert";
import AlertType from "../../../ui_components/Alert/AlertType";
import {useUserContext} from "../../../contexts/UserContext";
import Access from "../../Access/AllowAccess/Access";
import DeliveryPersonSelect from "../../Selects/DeliveryPersonSelect/DeliveryPersonSelect";
import ArticleWarehouseSelect from "../../Selects/ArticleWarehouseSelect/ArticleWarehouseSelect";
import DeliveryPerson from "../../../entities/DeliveryPerson";
import ArticleWarehouse from "../../../entities/productOrder/article/ArticleWarehouse";
import ArticlesStockAmountSelect from "../../Selects/ArticlesStockAmountSelect/ArticlesStockAmountSelect";
import { ArticleAmountItem } from "../../Selects/ArticlesStockAmountSelect/ArticlesStockAmountSelectProperties";

const TransferArticleToWarehouseButton: React.FC<TransferArticleToWarehouseButtonProperties> = ({
                                                                              onClick = () => {
                                                                              },
                                                                              onSave = () => {
                                                                              },
                                                                              selectedFrom,
                                                                              selectedTo,
                                                                              showIcon = true,
                                                                              showText = true,
                                                                              disabled,
                                                                              className = "",
                                                                              rounded = false,
                                                                              size = ButtonSize.DEFAULT,
                                                                              type = ButtonType.DEFAULT,
                                                                          }) => {
    const classes = useStyles();

    const i18n = useI18nContext();
    const userStore = useUserContext();
    const commonContext = useCommonContext();
    const store = new TransferArticleToWarehouseStore(commonContext, selectedFrom, selectedTo);

    if (!userStore.hasAccess(Access.TRANSFER_ARTICLES_BETWEEN_DELIVERY_PERSON.valueOf())) {
        return <></>;
    }

    const handleOnclick = async () => {
        await store.openModal();
        onClick();
    };

    const onCloseModal = () => {
        store.error = undefined;
        store.fromError = undefined;
        store.toError = undefined;
        store.closeModal();
        if (onSave) {
            onSave();
        }
    };

    const onCommentChange = (newComment: string) => (store.comment = newComment);
    const onFromChange = (d?: DeliveryPerson) => (store.from = d);
    const onToChange = (w?: ArticleWarehouse) => (store.to = w);

    const onArticlesChange = (updatedItems: ArticleAmountItem[]) => {
        store.articles = updatedItems;
    };

    const onArticleTransferSave = async () => {
        const saved = await store.save();
        if (saved) {
            store.closeModal();
            onSave && onSave();
        }
    };

    const basicText = i18n.translate("TRANSFER_ARTICLE_TO_WAREHOUSE");
    const Icon = WarehouseIcon;
    const Btn = () => {
        if (rounded) {
            return (
                <RoundedButton
                    onClick={handleOnclick}
                    className={className}
                    disabled={disabled}
                    tooltip={!showText ? basicText : ""}
                    text={showText ? basicText : ""}
                    type={type}
                    icon={showIcon ? <Icon/> : <></>}
                />
            );
        }
        return (
            <Button
                text={showText ? basicText : ""}
                className={className}
                tooltip={!showText ? basicText : ""}
                disabled={disabled}
                size={size}
                onClick={handleOnclick}
                type={type}
                startIcon={showIcon ? <Icon/> : <></>}
            />
        );
    };

    return (
        <Observer>
            {() => (
                <>
                    <Modal
                        fullScreen={false}
                        loading={store.loading}
                        title={basicText}
                        onClose={onCloseModal}
                        open={store.isModalOpen}
                    >
                        <div className={classes.modal_container}>
                            {/* Campos Fixos */}
                            <DeliveryPersonSelect
                                fullWidth
                                label={i18n.translate("FROM_USER")}
                                className={classes.input}
                                selected={store.from}
                                onChange={onFromChange}/>
                            <ArticleWarehouseSelect
                                fullWidth
                                label={i18n.translate("ARTICLE_WAREHOUSE_SINGULAR")}
                                className={classes.input}
                                selected={store.to}
                                onChange={onToChange}/>
                            <CommentInput
                                lines={3}
                                onChange={onCommentChange}
                                fullWidth
                                value={store.comment}
                                className={classes.input}
                            />

                            <ArticlesStockAmountSelect
                                label={i18n.translate("ARTICLES")}
                                required
                                items={store.articles}
                                onChange={onArticlesChange}
                                entityId={store.from ? store.from.id : ''}
                                disabled={disabled}
                            />

                            {/* Alertas */}
                            {store.error && (
                                <Alert
                                    className={classes.alert}
                                    text={`${i18n.translate(store.error)}`}
                                    type={AlertType.DANGER}
                                />
                            )}

                            <div className={classes.btn_container}>
                                <Button
                                    loading={store.loading}
                                    className={classes.input}
                                    onClick={onArticleTransferSave}
                                    disabled={!store.enableButton}
                                    type={ButtonType.SECONDARY}
                                    text={i18n.translate("SAVE")}
                                />
                            </div>

                        </div>
                    </Modal>
                    <Btn/>
                </>
            )}
        </Observer>
    );
};

export default TransferArticleToWarehouseButton;
